export default "__VITE_ASSET__5abbb675__"